export default "__VITE_ASSET__D8NsT7Ro__"